import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Toastiy from "./Toastiy";
import { useAuth0 } from "@auth0/auth0-react";

const SessionExpired = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const logoutUser = () => {
        localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  useEffect(() => {
    logoutUser();
    Toastiy("Session Expired. Login Required!");
    localStorage.removeItem("token");
    navigate("/login");
  }, []);
};

export default SessionExpired;
